import { Box, Heading } from '@chakra-ui/react';
import { Prose } from '@/components/ui/prose';

interface Props {
  block: {
    type: number;
    label: string;
  };
  content: any;
}

export default function TextBlock({ block, content }: Props) {
  return (
    <Box>
      <Heading as={'h3'} fontSize={'xl'} mb={2}>
        {block.label}
      </Heading>
      <Box pl={2}>
        <Prose size='md'>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </Prose>
      </Box>
    </Box>
  );
}
